import React from "react";
import { useLocation, Link } from "react-router-dom";

function MobileMenu({ items }) {
  const location = useLocation();

  return (
    <div className="mobile-menu-wrapper">
      <div className="mobile-menu">
        <div className="mobile-menu-items">
          {items.map((item) => {
            if (item.key === "exit") {
              return (
                <span
                  key={item?.key}
                  onClick={item?.label?.props?.onClick}
                  className="mobile-menu-item"
                >
                  {item?.label?.props?.children}
                  {item?.icon}
                </span>
              );
            }
            if (item.key === "notifications") {
              return (
                <Link
                  to={item?.label?.props?.children?.props?.to}
                  className="mobile-menu-item"
                  key={item?.key}
                  style={{
                    background:
                      location?.pathname === item?.label?.props?.children?.props?.to &&
                      "#1DA57A",
                  }}
                >
                  {item?.label?.props?.children?.props?.children}
                  {item?.icon}
                </Link>
              );
            }
            if (item.key !== "exit") {
              return (
                <Link
                  to={item?.label?.props?.to}
                  className="mobile-menu-item"
                  key={item?.key}
                  style={{
                    background:
                      location?.pathname === item?.label?.props?.to &&
                      "#1DA57A",
                  }}
                >
                  {item?.label?.props?.children}
                  {item?.icon}
                </Link>
              );
            }
          })}
        </div>
      </div>
    </div>
  );
}

export default MobileMenu;
